import { css } from '@emotion/css';
import { theme } from 'Shared/frontend/SettingsProvider';
import { Match, Switch } from 'solid-js';

export function IgnorePageMarginsStyle(P:{disable?:boolean,children})
{
	const ignoreMarginsStyle = () => {
		/* 100cqw here is require for previews */
		const max = `min(${theme().main.maxWidth}px, 100cqw)`;
		const left = theme().sideMargins.left;
		const right = theme().sideMargins.right;

		return css({
			maxWidth: '100cqw',
			marginLeft:  `calc(0px - max(${left}, (100cqw - ${max}) / 2))`,
			marginRight: `calc(0px - max(${right},(100cqw - ${max}) / 2))`,
		});
	}

	/* The outer div is position:static by default - required for the position:relative */
	return (
		<Switch>
			<Match when={P.disable}>
				{P.children}
			</Match>
			<Match when={true}>
				<div class={ignoreMarginsStyle()}>
					{P.children}
				</div>
			</Match>
		</Switch>
	);
}
 
